import axios from 'axios';
import React, { Component } from 'react';
import {
  Button,
  Container,
  Col,
  Form,
  FormControl,
  Row,
} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';

export default class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(this.props.location.search);
    this.state = {
      firstName: '',
      lastName: '',
      emailAddress: this.props.match.params.email,
      confirmEmailAddress: '',
      parcelnumber: searchParams.get('parcelnumber')
        ? searchParams.get('parcelnumber')
        : '',
      errors: {},
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  noPaste(event) {
    event.preventDefault();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      if ((await this.isEmailRegistered()) === false) {
        const eAlertsCoreRequest = eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT)
          .register({
            firstName: this.state.firstName.toUpperCase(),
            lastName: this.state.lastName.toUpperCase(),
            emailAddress: this.state.emailAddress.toUpperCase(),
            parcelNumber: this.state.parcelnumber,
          })
          .then((Response) => {
            if (Response.status === 200) {
              const ref = '/checkemail';
              //redirect to check email page
              this.props.history.push(ref);
            }
          })
          .catch(() => {
            const ref = '/error';
            this.props.history.push(ref);
          });

        await axios
          .all([eAlertsCoreRequest])
          .then(axios.spread((...responses) => {}))
          .catch(() => {
            const ref = '/error';
            this.props.history.push(ref);
          });
      } else {
        const ref = '/login';
        //we found their email, prompt to login instead of register
        this.props.history.push(ref);
      }
    }
  }

  validate() {
    let errors = {};
    let isValid = true;
    var pattern = new RegExp(/.+@.+\..+/i);

    if (!this.state.firstName) {
      isValid = false;
      errors['firstName'] = 'Please enter your first name.';
    }

    if (!this.state.lastName) {
      isValid = false;
      errors['lastName'] = 'Please enter your last name.';
    }

    if (typeof this.state.emailAddress !== 'undefined') {
      if (!pattern.test(this.state.emailAddress)) {
        isValid = false;
        errors['emailAddress'] = 'Please enter valid email address.';
      }
    }

    if (!this.state.emailAddress) {
      isValid = false;
      errors['emailAddress'] = 'Please enter your email address.';
    }

    if (this.state.emailAddress !== this.state.confirmEmailAddress) {
      isValid = false;
      errors['confirmEmailAddress'] = 'Emails must match.';
    }

    if (typeof this.state.confirmEmailAddress !== 'undefined') {
      if (!pattern.test(this.state.confirmEmailAddress)) {
        isValid = false;
        errors['confirmEmailAddress'] = 'Please enter valid email address.';
      }
    }

    if (!this.state.confirmEmailAddress) {
      isValid = false;
      errors['confirmEmailAddress'] = 'Please enter your email address again.';
    }

    this.setState({
      errors: errors,
    });

    return isValid;
  }

  async isEmailRegistered() {
    let emailRegistered = true;
    let loginObject = {
      email: this.state.emailAddress
    };
    await eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT)
      .login(loginObject)
      .then((Response) => {
        if (Response.status === 204) {
          emailRegistered = false;
        }
      })
      .catch(() => {
        const ref = '/error';
        this.props.history.push(ref);
      });
    return emailRegistered;
  }

  render() {
    return (
      <Container fluid="md">
        <Helmet>
          <title>Register{process.env.REACT_APP_PAGETITLE_TEXT}</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Row>
          <Col xs={2}></Col>
          <Col xs={8}>
            <br />
            <h2>
              Since you have not previously registered for Property eAlerts
              using this email, please complete the form below.
            </h2>

            <Form onSubmit={this.handleSubmit} noValidate>
              <Form.Group as={Row} className="mb-3">
                <Col sm={9}>
                  <FormControl
                    name="firstName"
                    placeholder="First Name"
                    aria-label="First Name"
                    value={this.state.firstName}
                    onChange={this.handleInputChange}
                  />
                  <Form.Text className="text-danger">
                    {this.state.errors.firstName}
                  </Form.Text>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3">
                <Col sm={9}>
                  <FormControl
                    name="lastName"
                    placeholder="Last Name"
                    aria-label="Last Name"
                    value={this.state.lastName}
                    onChange={this.handleInputChange}
                  />
                  <Form.Text className="text-danger">
                    {this.state.errors.lastName}
                  </Form.Text>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3">
                <Col sm={9}>
                  <FormControl
                    name="emailAddress"
                    placeholder="Email Address"
                    aria-label="Email Address"
                    autoComplete="nope"
                    type="email"
                    value={this.state.emailAddress}
                    onChange={this.handleInputChange}
                  />
                  <Form.Text className="text-danger">
                    {this.state.errors.emailAddress}
                  </Form.Text>
                </Col>
              </Form.Group>
              <Form.Group as={Row} className="mb-3">
                <Col sm={9}>
                  <FormControl
                    name="confirmEmailAddress"
                    placeholder="Confirm Email Address"
                    aria-label="Confirm Email Address"
                    autoComplete="nope"
                    onDrop={this.noPaste}
                    onPaste={this.noPaste}
                    type="email"
                    value={this.state.confirmEmailAddress}
                    onChange={this.handleInputChange}
                  />
                  <Form.Text className="text-danger">
                    {this.state.errors.confirmEmailAddress}
                  </Form.Text>
                </Col>
              </Form.Group>
              <Form.Group>
                <Button
                  variant="outline-dark"
                  className="m-1"
                  size="md"
                  onClick={() => this.props.history.goBack()}
                >
                  Cancel
                </Button>
                <Button className="m-1" size="md" type="submit">
                  Continue
                </Button>
              </Form.Group>
            </Form>
          </Col>
          <Col xs={2}></Col>
        </Row>
      </Container>
    );
  }
}
